var map = {
	"./Icon-email.svg": 7230,
	"./Icon-phone.svg": 3570,
	"./Telegram_logo.svg": 5067,
	"./UPX-desktop.png": 9828,
	"./UPX-desktop.webp": 9417,
	"./UPX-mobile.png": 7704,
	"./UPX-mobile.webp": 1445,
	"./arrow-right-solid.png": 1154,
	"./currencies/AZN.png": 5217,
	"./currencies/AZN.webp": 602,
	"./currencies/KZT.png": 5865,
	"./currencies/KZT.webp": 3458,
	"./currencies/RUB.png": 5387,
	"./currencies/RUB.webp": 6736,
	"./currencies/UAH.png": 9554,
	"./currencies/UAH.webp": 7187,
	"./flags/AZ.png": 7401,
	"./flags/AZ.webp": 4626,
	"./flags/KZ.png": 9583,
	"./flags/KZ.webp": 2508,
	"./flags/RU.png": 9679,
	"./flags/RU.webp": 5436,
	"./flags/UA.png": 1430,
	"./flags/UA.webp": 6287,
	"./icon-chevron-down.svg": 3768,
	"./icon-cross.svg": 5922,
	"./icon-eye.svg": 8109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;